<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:29:22
 * @LastEditTime: 2019-08-22 19:28:32
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="container">
    <div class="pageTitle">入库管理</div>

    <el-button
      type="primary"
      @click="showLink = !showLink"
      style="width: 150px; height: 40px; margin: 20px"
      class="btnColor"
      >手机端登陆地址</el-button
    >
    <copyLinkDialog @handleClose="closeLink" v-if="showLink" />
    <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
      <el-form-item label="入库时间:" style="text-align: center">
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="开始时间"
            v-model="form.start_time"
            style="width: 100%"
          ></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">-</el-col>
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="结束时间"
            v-model="form.end_time"
            style="width: 100%"
          ></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="出货单号:">
        <el-input v-model="form.stock_out_sn" clearable></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSearch()">搜索</el-button>
        <el-button type="primary" @click="onexport">导出</el-button>
      </el-form-item>
    </el-form>
    <!--表格-->
    <div style="margin-bottom: 10px">
      总计录: <span style="color: red">{{ total }}</span> 总入库数:<span
        style="color: red"
        >{{ sum }}</span
      >
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      v-loading="loading"
      border
      stripe
      height="350"
      style="width: 100%"
    >
      <el-table-column label="相关出货单号" prop="stock_out_sn" fixed> </el-table-column>
      <el-table-column prop="from_name" label="出货人" fixed> </el-table-column>
      <el-table-column prop="real_stock_out_num" label="入库数量"> </el-table-column>
      <el-table-column prop="inwarehouse_at" label="入库时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="remarks" label="备注" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="product_name" label="操作" show-overflow-tooltip>
        <template slot-scope="scope">
          <span
            style="color: red; cursor: pointer; margin-right: 10px"
            @click="detail(scope.row)"
            >查看详情</span
          >
          <span
            style="color: red; cursor: pointer"
            @click="confirm(scope.row)"
            v-if="scope.row.status == 1"
            >确认入库</span
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      style="margin: 20px 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNo"
      :page-sizes="[20, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalSize"
    >
    </el-pagination>

    <instockDetailDialog
      :detailData="stock_out_sn"
      @handleClose="close()"
      v-if="instockDetailDialogVisable"
    />
  </div>
</template>

<script>
import deliverDialog from "./deliverDialog";
import instockDetailDialog from "./instockDetail";
import copyLinkDialog from "@/common/copyLinkDialog";
export default {
  name: "instock-manage",
  data() {
    return {
      showLink: false,
      total: 0,
      form: {
        product_sn: "",
        stock_in_sn: "",
        production_batch: "",
        product_name: "",
        start_time: "",
        end_time: "",
        stock_out_sn: "",
      },
      tableData: [],
      instockDetailDialogVisable: false,
      stock_out_sn: "", //查看明细传递的入库单号
      delData: {}, //发货
      instock: 0,
      total: 0,
      //分页
      pageNo: 1,
      pageSize: 20,
      totalSize: 0,
      loading: false,
      sum: 0,
    };
  },
  methods: {
    getLastMonth() {
      var now = new Date();
      var year = now.getFullYear(); //getYear()+1900=getFullYear()
      var month = now.getMonth() + 1; //0-11表示1-12月
      var day = now.getDate();
      var dateObj = {};
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      if (parseInt(day) < 10) {
        day = "0" + day;
      }

      dateObj.now = year + "-" + month + "-" + day;

      if (parseInt(month) == 1) {
        //如果是1月份，则取上一年的12月份
        dateObj.last = parseInt(year) - 1 + "-12-" + day;
        return dateObj;
      }

      var preSize = new Date(year, parseInt(month) - 1, 0).getDate(); //上月总天数
      if (preSize < parseInt(day)) {
        //上月总天数<本月日期，比如3月的30日，在2月中没有30
        dateObj.last = year + "-" + month + "-01";
        return dateObj;
      }

      if (parseInt(month) <= 10) {
        dateObj.last = year + "-0" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      } else {
        dateObj.last = year + "-" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      }
    },
    closeLink() {
      this.showLink = false;
    },
    //请求列表数据
    onSearch() {
      let beginstr = "",
        endstr = "";
      if (this.form.start_time) {
        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD");
      }
      if (this.form.end_time) {
        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
      }
      this.loading = true;
      this.$get("logistics_1", "/inwarehouses", {
        lang: "",
        start_time: beginstr,
        end_time: endstr,
        product_sn: this.form.product_sn,
        stock_out_sn: this.form.stock_out_sn,
        is_export: 0,
        per_page: this.pageSize,
        page: this.pageNo,
      })
        .then((res) => {
          this.loading = false;
          //console.log(res);
          this.tableData = res.data;
          this.totalSize = res.meta.total;
          this.total = res.count;
          this.sum = res.sum;
        })
        .catch(function (error) {
          this.loading = false;
          console.log(error);
        });
    },
    //导出
    onexport() {
      let beginstr = "",
        endstr = "";
      if (this.form.start_time) {
        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD");
      }
      if (this.form.end_time) {
        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
      }
      var access_tokens = localStorage.getItem("access_token");
      var url =
        process.env.VUE_APP_URL_V1 +
        "/inwarehouses.export?start_time=" +
        beginstr +
        "&end_time=" +
        endstr +
        "&stock_out_sn=" +
        this.form.stock_out_sn +
        "&is_export=1" +
        "&signature=" +
        this.$md5(access_tokens);
      window.open(url);
    },
    //物流吗明细
    detail(row) {
      this.stock_out_sn = row.stock_out_sn;
      this.instockDetailDialogVisable = true;
    },
    /*修改入库*/
    editInstock(row) {
      this.$router.push({
        name: "editInstock",
        query: {
          stock_in_sn: row.stock_in_sn,
        },
      });
    },
    //打印入库单
    print(row) {
      this.$router.push({
        name: "printInstock",
        query: {
          stock_in_sn: row.stock_in_sn,
        },
      });
    },
    /*分页*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.onSearch();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.onSearch();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    close() {
      this.instockDetailDialogVisable = false;
    },
    //删除
    confirm(row) {
      this.$confirm("是否确认入库?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let str = row.stock_out_sn,
            url = "/inwarehouses/" + str + "/confirm";
          this.$get("logistics_1", url, {})
            .then((res) => {
              this.$message({
                type: "success",
                message: "确认入库成功!",
              });
              this.onSearch();
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error.message,
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消入库",
          });
        });
    },
  },
  created() {
    console.log(process.env.VUE_APP_URL_V1);
    this.form.start_time = this.getLastMonth().last;
    this.form.end_time = this.getLastMonth().now;
    this.onSearch();
  },
  components: {
    copyLinkDialog,
    instockDetailDialog,
  },
};
</script>
<style lang="scss" scoped></style>
